"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformToDateWithoutTime = void 0;
const class_transformer_1 = require("class-transformer");
const TransformToDateWithoutTime = (target, propertyKey) => {
    (0, class_transformer_1.Type)(() => Date)(target, propertyKey);
    (0, class_transformer_1.Transform)(({ value }) => {
        if (!value) {
            return undefined;
        }
        const d = new Date(value);
        // We want to lose all time information, so we set the time to 00:00:00
        return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
    })(target, propertyKey);
};
exports.TransformToDateWithoutTime = TransformToDateWithoutTime;
//# sourceMappingURL=TransformToDateWithoutTime.js.map